import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CoreService, DialogService, DspxCardSetBaseFormComponent, SpinnerService } from 'dspx-core';
import { API_ENDPOINTS } from '../../constants/api-endpoints.constants';
import { FILTER_QUESTION_CODES, NAV_TAB_NUMBERS, PAGE_NUMBERS, QUESTION_CODES, SECTION_CODES } from '../../constants/app-data.constants';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';
import { TEMPLATES } from '../../constants/templates.constants';
import { Mapper, MapperBuilder } from '../../helpers/mapper';
import { VendorGridFilterRequest } from '../../interfaces/vendor-grid-filter-request.interface';
import { AppDataService } from '../../services/app-data.service';
import { ResponseParserService } from '../../services/response-parser.service';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';

@Component({
  selector: 'app-vendor-list',
  templateUrl: './vendor-list.component.html',
  styleUrl: './vendor-list.component.scss'
})
export class VendorListComponent extends BaseCardSetListComponent implements OnInit {
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  filterQuestionToFilterModelMapper: Mapper;
  activeDialog: string = '';

  constructor(
    protected router: Router,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    private coreService: CoreService
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.vendorList,
      () => API_ENDPOINTS.dashboard.getVendors,
      false);

    this.filterQuestionToFilterModelMapper =
      new MapperBuilder()
        .WithDefaultTargetFieldMapping(/Filter$/i, "") // When target field name is not specified, just use the source field's name, but drop "Filter" from the end
        .MapFrom(FILTER_QUESTION_CODES.vendorListForm.eppVendorIdFilter)
        .MapFrom(FILTER_QUESTION_CODES.vendorListForm.oracleVendorIdFilter)
        .MapFrom(FILTER_QUESTION_CODES.vendorListForm.vendorNameFilter)
        .BuildMapper();
  }

  ngOnInit(): void {
  }

  formLoad(event: any): void {
    this.loadGridDataOnFormLoad();
  }

  filterData(event: any): void {
    switch (event.field.key) {
      case QUESTION_CODES.vendorListForm.vendorListFilter:
        {
          const filterRequest = this.getVendorFilterRequest();
          this.loadGridData(filterRequest);
          break;
        }
    }
  }

  actionButton_vendorGrid_datagrid_edit_Clicked(event: any): void {
    this.router.navigate(['/', ROUTE_CONSTANTS.vendor.prefix, event.event.data.id]);
  }

  private getVendorFilterRequest(): VendorGridFilterRequest {
    const filterModel = this.getQuestionValue(
      this.model,
      NAV_TAB_NUMBERS.vendorListForm.vendors,
      PAGE_NUMBERS.vendorListForm.vendors,
      SECTION_CODES.vendorListForm.vendor,
      QUESTION_CODES.vendorListForm.vendorListFilter
    );

    return this.filterQuestionToFilterModelMapper.Map(filterModel);
  }
}
